// src/components/Hero.jsx
import React from 'react';
import { motion } from 'framer-motion';
import Header from './Header';

const Hero = () => {
  return (
    <section id="home" className="hero-section">
      <Header />
      <div className="hero-content">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="container"
        >
          <h1>Pioneers in Bahrain's Infrastructure Development</h1>
          <p className="subtitle">
            Delivering excellence in civil construction, sewerage systems, and electro-mechanical 
            works for over three decades.
          </p>
          <div className="hero-highlights">
            <div className="highlight-item">
              <h3>50+</h3>
              <p>Years of Experience</p>
            </div>
            <div className="highlight-item">
              <h3>1000+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="highlight-item">
              <h3>100%</h3>
              <p>Client Satisfaction</p>
            </div>
          </div>
        </motion.div>
      </div>
      <div className="scroll-down">
        <div className="arrow"></div>
      </div>
    </section>
  );
};

export default Hero;